/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css2?family=Muli:ital,wght@0,400;0[_ngcontent-%COMP%], 500[_ngcontent-%COMP%];0[_ngcontent-%COMP%], 700[_ngcontent-%COMP%];1[_ngcontent-%COMP%], 400&display=swap)[_ngcontent-%COMP%];mat-table[_ngcontent-%COMP%]{max-height:490px;overflow-y:auto;color:#1a3349}mat-table[_ngcontent-%COMP%]   mat-cell[_ngcontent-%COMP%]{overflow:visible}@media (max-width:599px){mat-table[_ngcontent-%COMP%]   mat-cell[_ngcontent-%COMP%]:last-child{padding-right:0}}"];
export { styles as styles };
